import React from 'react';
import EInvoicingPortal from './EInvoicingPortal';

const EInvoicingPortalContainer = (props) => {
  return <EInvoicingPortal {...props} />;
};

export default React.memo(EInvoicingPortalContainer);
